var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c("section", { staticClass: "section" }, [
        _c("div", { staticClass: "title" }, [_vm._v("供应商信息")]),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "content_left" }, [
            _c("div", { staticClass: "content_item" }, [
              _c("span", [_vm._v(_vm._s(_vm.getProtocolLabel()) + "：")]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.protocolOption[_vm.detailData.protocol] || "-")
                ),
              ]),
            ]),
            _vm.detailData.castType !== "push"
              ? _c("div", { staticClass: "content_item" }, [
                  _c("span", [_vm._v("房间号：")]),
                  _c("span", [_vm._v(_vm._s(_vm.detailData.roomNo || "-"))]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "content_right" }, [
            _c("div", { staticClass: "content_item" }, [
              _c("span", [_vm._v("开始时间：")]),
              _c("span", [_vm._v(_vm._s(_vm.detailData.createTime || "-"))]),
            ]),
            _c("div", { staticClass: "content_item" }, [
              _c("span", [_vm._v("结束时间：")]),
              _c("span", [_vm._v(_vm._s(_vm.detailData.endTime || "-"))]),
            ]),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "section" }, [
        _c("div", { staticClass: "title" }, [_vm._v("成员列表")]),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%", "margin-top": "10px" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", { attrs: { prop: "uid", label: "uid" } }),
          _c("el-table-column", {
            attrs: { prop: "username", label: "用户名" },
          }),
          _c("el-table-column", {
            attrs: { prop: "mobile", label: "手机号码" },
          }),
          _c("el-table-column", {
            attrs: { prop: "dType", label: "类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            {
                              1: "TV",
                              2: "安卓",
                              3: "苹果",
                              5: "PC",
                              7: "dongle",
                              8: "web",
                            }[parseInt(+scope.row.dType / 1000)] ||
                              scope.row.dType
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleClick(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }